import docReady from './Functions/docReady'
import initDropdowns from './Functions/initDropdowns'
import SVGInjector from './Functions/svgInjector'
import { buildVisiblePrice } from './Functions/buildVisiblePrice.js'
import { parseMarkdown } from './Functions/parseMarkdown.js'
import tippy, { followCursor } from 'tippy.js';

docReady(function () {
    SVGInjector(document.querySelectorAll('img.inject-svg'));
    initDropdowns();
    tippy('[data-tippy-content]', {
        followCursor: 'horizontal',
        plugins: [followCursor],
        maxWidth: 'none',
        touchHold: true
    });
});

// Väärtustame Axiose päringute XSRF tokeni vastavast HTML'i tag'ist
// CookieName peab siin undefined olema, sest muidu kirjutab Axiod käsitsi sätitud headeri üle
axios.defaults.xsrfCookieName = undefined;
axios.defaults.headers.common['X-XSRF-TOKEN'] = document.getElementById('RequestVerificationToken').value;

String.prototype.pluralize = function (count, pluralForm) {
    if (count === 1) {
        return this.toString();
    }
    return pluralForm;
};

String.prototype.format = function () {
    var formatted = this;
    for (var i = 0; i < arguments.length; i++) {
        var regexp = new RegExp('\\{' + i + '\\}', 'gi');
        formatted = formatted.replace(regexp, arguments[i]);
    }
    return formatted;
};

let budgetInterval;
Vue.component('file-settings-icon', {
    template: '#file-settings-icons-template',
    props: ['iconGroup', 'iconInGroup', 'tooltip', 'duplexMode'],
});
if (document.getElementById('app-main')) {
    const appMain = new Vue({
    el: '#app-main',
    data: {
        media: {
            isMediaXs: false,
            isMediaSm: false,
            isMediaMd: false,
            isMediaLg: false,
            isMediaXl: false,
            isMediaXxl: false
        },
        notifications: [],
        isUserAuthenticated: false,
        currentBudget: {}
    },
    methods: {
        removeNotification: function (notification) {
            var index = this.notifications.indexOf(notification);
            if (index !== -1) {
                this.notifications.splice(index, 1);
            } else {
                this.notifications = this.notifications.filter(x => x !== notification);
            }
        },
        getUserBudget: function () {
            if (this.isUserAuthenticated && this.currentBudget.userId != 'guest') {
                axios.get('/api/v1.0/me/budget')
                    .then((response) => {
                        this.currentBudget = response.data;
                        if (appUserMenu) {
                            appUserMenu.currentBudget = this.currentBudget;
                        }
                    })
                    .catch((error) => {
                        if (error.response.status === 401) {
                            console.log(error.response);
                        }
                        else {
                            console.log(error);
                        }
                    });
            }
        },
    },
    computed: {
        visibleBudget: function () {
            if (this.currentBudget.budget !== undefined) {
                return buildVisiblePrice(this.currentBudget.budget, this.currentBudget.currencyInfo);
            }
        }
    },
    mounted: function () {
        // console.log('appMain mounted');
        // Initialize page width breakpoints
        const mqXs = window.matchMedia('(max-width: 575px)');
        const mqSm = window.matchMedia('(min-width: 576px) and (max-width: 767px)');
        const mqMd = window.matchMedia('(min-width: 768px) and (max-width: 991px)');
        const mqLg = window.matchMedia('(min-width: 992px) and (max-width: 1199px)');
        const mqXl = window.matchMedia('(min-width: 1200px) and (max-width: 1399px)');
        const mqXxl = window.matchMedia('(min-width: 1400px)');

        this.media.isMediaXs = mqXs.matches;
        this.media.isMediaSm = mqSm.matches;
        this.media.isMediaMd = mqMd.matches;
        this.media.isMediaLg = mqLg.matches;
        this.media.isMediaXl = mqXl.matches;
        this.media.isMediaXxl = mqXxl.matches;

        mqXs.addListener(function (e) {
            this.media.isMediaXs = e.matches;
        }.bind(this));
        mqSm.addListener(function (e) {
            this.media.isMediaSm = e.matches;
        }.bind(this));
        mqMd.addListener(function (e) {
            this.media.isMediaMd = e.matches;
        }.bind(this));
        mqLg.addListener(function (e) {
            this.media.isMediaLg = e.matches;
        }.bind(this));
        mqXl.addListener(function (e) {
            this.media.isMediaXl = e.matches;
        }.bind(this));
        mqXxl.addListener(function (e) {
            this.media.isMediaXxl = e.matches;
        }.bind(this));

        if (model.notifications !== undefined) {
            this.notifications = model.notifications;
        }
        var loggedIn = document.getElementById('isLoggedIn').value;
        if (loggedIn === 'true') {
            this.isUserAuthenticated = true;
            var confirmedMails = document.getElementById('confirmedMails');
            let noEmailsMessage = confirmedMails.dataset.message;
            //'Konto küljes pole ühtegi kinnitatud e-maili, probleemide korral ei saa me teiega ühendust. Lisa e-mail seadete lehel.'
            if (!confirmedMails.value) {
                this.notifications.push({ type: 'warning', message: noEmailsMessage  });
            }
        }
        
        this.getUserBudget();

        budgetInterval = setInterval(function () {
            this.getUserBudget();
        }.bind(this), 15000);
    }
});

    window.appMain = appMain;
}

document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
        // tab inactive
        clearInterval(budgetInterval);
    }
    else {
        // tab active
        appMain.getUserBudget();
        budgetInterval = setInterval(function () {
            appMain.getUserBudget();
        }.bind(appMain), 15000);
    }
});

/* FEEDBACK START */
if (document.getElementById('feedback-wrapper')) {
    const feedback = new Vue({
        el: '#feedback-wrapper',
        data: {
            showFeedback: false,
            feedbackComment: '',
            feedbackEmail: '',
            submitted: false,
            messages: [],
            showError: false,
        },
        methods: {
            leftInput: function () {
                this.showError = true;
            },
            toggleFeedback: function () {
                this.showFeedback = !this.showFeedback;
                if (this.showFeedback) {
                    var primaryMail = document.getElementById('primaryMail');
                    if (primaryMail) {
                        this.feedbackEmail = primaryMail.value;
                    }
                    this.feedbackComment = '';
                    this.submitted = false;
                    this.messages = [];
                    Vue.nextTick(() => {
                        if (this.$refs.feedbackInput) {
                            this.$refs.feedbackInput.focus();
                        }
                    });
                }
            },
            submitFeedback: function () {
                if (!this.isDisabled) {
                    this.submitted = true;
                    this.messages = [];

                    axios.post('/api/v1.0/feedback', {
                        email: this.feedbackEmail,
                        comment: this.feedbackComment,
                        userAgent: navigator.userAgent
                    }).then(function (response) {
                        let messageSuccess = document.getElementById('feedback-wrapper').dataset.messageSuccess;
                        this.messages.push({ type: 'success', text: messageSuccess });
                        this.showFeedback = false;
                        appMain.notifications.push({ type: 'success', message: messageSuccess });
                    }.bind(this)).catch(function (error) {
                        if (error.response) {
                            if (error.response.data.errors) {
                                Object.keys(error.response.data.errors).forEach(key => {
                                    error.response.data.errors[key].forEach(errorMessage => {
                                        this.messages.push({ type: 'error', text: errorMessage });
                                        appMain.notifications.push({ type: 'error', message: errorMessage });
                                    });
                                });
                            }
                            if (error.response.status === 500) {
                                // TODO - Veateade tõlgitavaks
                                this.messages.push({ type: 'error', text: 'Server error! Please try again.' })
                                appMain.notifications.push({ type: 'error', message: 'Server error! Please try again.' });
                            }
                            this.showFeedback = false;
                        } else {
                            // TODO - Veateade tõlgitavaks no internet
                            this.messages.push({ type: 'error', text: 'error' })
                            appMain.notifications.push({ type: 'error', message: 'error' });
                            this.showFeedback = false;
                        }
                    }.bind(this))

                    
                }
            }
        },
        computed: {
            isDisabled: function () {
                return this.feedbackComment.length < 5 || !this.isEmailValid || (this.submitted && !this.messages.length);
            },
            isEmailValid: function () {
                return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(this.feedbackEmail)
            }
        }
    });
    const feedbackButtons = document.getElementsByClassName('feedbackToggle');
    for (let i = 0; i < feedbackButtons.length; i++) {
        feedbackButtons[i].addEventListener('click', function () {
            feedback.toggleFeedback();
        })
    }
}
/* FEEDBACK END */

/* ALERT START */
if (document.getElementById('alert-wrapper')) {
    const alert = new Vue({
        el: '#alert-wrapper',
        data: {
            showAlertModal: false,
            alertMarkdown: ''
        },
        methods: {
            toggleAlertModal: function () {
                this.showAlertModal = !this.showAlertModal;
            }
        },
        computed: {
            showAlertIndicator: function () {
                return this.alertMarkdown !== '';
            },
            alertMessage: function () {
                return parseMarkdown(this.alertMarkdown);
            }
        },
        mounted: function () {
            axios.get('/api/v1.0/alerts')
                .then((response) => {
                    this.alertMarkdown = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    });
}
/* ALERT END */

/* BURGER START */
let burger;
if (document.getElementById('burger')) {
    burger = new Vue({
        el: '#burger',
        data: {
            showMenu: false,
            media: appMain.media,
        },
        methods: {
            toggleMenu: function () {
                SVGInjector(document.querySelectorAll('img.inject-svg'));
                if (this.media.isMediaSm === true || this.media.isMediaXs === true) {
                    this.showMenu = !this.showMenu;
                    burgerbackdrop.showMenu = this.showMenu;
                    this.showMenu ? document.getElementById('navbar').style.height = "calc(100% + 5px)" : document.getElementById('navbar').style.height = "auto";
                    Vue.nextTick(function () {
                        SVGInjector(document.querySelectorAll('img.inject-svg'));
                    })

                }

            },
        },
        watch: {
            media: {
                deep: true,
                handler: function (val) {
                    if (val.isMediaSm != true && val.isMediaXs != true) {
                        this.showMenu = false;
                        burgerbackdrop.showMenu = false;
                        document.getElementById('navbar').style.height = "auto";
                    }
                }
            },
        },
    });
}

let burgerbackdrop;
if (document.getElementById('burger-backdrop')) {
    burgerbackdrop = new Vue({
        el: '#burger-backdrop',
        data: {
            showMenu: burger.showMenu,
        },
        methods: {
            backDropClick: function () {
                burger.toggleMenu();
            }
        },
    });
}
/* BURGER END */
let testobj;
if (document.getElementById('footer-vue-wrapper')) {
    testobj = new Vue({
        el: '#footer-vue-wrapper',
        data: {
            showMenu: false,
            media: appMain.media,
        },
        methods: {
            toggleMenu: function () {
                this.showMenu = !this.showMenu;
            }
        }
    });
}

let appUserMenu;
if (document.getElementById('user-menu')) {
    appUserMenu = new Vue({
        el: '#user-menu',
        data: {
            currentBudget: appMain.currentBudget,
            isUserAuthenticated: appMain.isUserAuthenticated
        },
        computed: {
            visibleBudget: function () {
                if (this.currentBudget.budget !== undefined) {
                    return buildVisiblePrice(this.currentBudget.budget, this.currentBudget.currencyInfo);
                }
            }
        },
        methods: {
            toggleMobileBurger: function () {
                burger.toggleMenu();
            }
        },
    });
    window.appUserMenu = appUserMenu;
}